import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Routes, Route, Navigate } from "react-router-dom";
import Main from "./pages/main/Main";
import Start from "./pages/start/Start";
import HowToPlay from "./pages/start/HowToPlay";
import SelectGoal from "./pages/start/SelectGoal";
import About from "./pages/about/About";
import GameResult from "./pages/result/GameResult";
import ComparePlans from "./pages/compare/ComparePlans";
import Demo from "./pages/demo/Demo";

const App = () => (
  <BrowserRouter>
    <Routes>
      <Route path="*" element={<Navigate to="/start" />}></Route>
      <Route path="/" element={<Start />}></Route>
      <Route path="/main" element={<Main />}></Route>
      <Route path="/start" element={<Start />}></Route>
      <Route path="/howtoplay" element={<HowToPlay />}></Route>
      <Route path="/selectgoal" element={<SelectGoal />}></Route>
      <Route path="/about" element={<About />}></Route>
      <Route path="/result" element={<GameResult />}></Route>
      <Route path="/compare" element={<ComparePlans />}></Route>
      <Route path="/demo" element={<Demo />}></Route>
    </Routes>
  </BrowserRouter>
);

export default App;
